import moment from 'moment';

export function isSameDay(a: any, b: any) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow
  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}

export const months = [
  { id: 1, label: 'Janeiro', value: '1' },
  { id: 2, label: 'Fevereiro', value: '2' },
  { id: 3, label: 'Março', value: '3' },
  { id: 4, label: 'Abril', value: '4' },
  { id: 5, label: 'Maio', value: '5' },
  { id: 6, label: 'Junho', value: '6' },
  { id: 7, label: 'Julho', value: '7' },
  { id: 8, label: 'Agosto', value: '8' },
  { id: 9, label: 'Setembro', value: '9' },
  { id: 10, label: 'Outubro', value: '10' },
  { id: 11, label: 'Novembro', value: '11' },
  { id: 12, label: 'Dezembro', value: '12' },
];

export const generateYears = (initialDate = '2015-01-01') => {
  let dateStart = moment(initialDate, 'YYYY-MM-DD');
  let dateEnd = moment();
  let years = [];

  while (dateEnd > dateStart || dateStart.format('YYYY') === dateEnd.format('YYYY')) {
    years.push(dateStart.format('YYYY'));
    dateStart.add(1, 'year');
  }
  return years;
};

export const years = (() => {
  const ye = generateYears();
  return ye.map((y) => ({ id: y, label: y, value: y }));
})();

export const getDifferenceInYears = (startDate: moment.Moment, endDate: moment.Moment) => {
  return startDate.diff(endDate, 'year');
};
